
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M.75.583h3.667v1.833H.75z"}}),_c('path',{attrs:{"d":"M7.168 1.5h10.083","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M7.168 12.5h10.083","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M7.168 7h10.083","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"fill":"currentColor","d":"M.75 7.917h3.667V6.084H.75z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M.75 13.417h3.667v-1.833H.75z"}})])
          )
        }
      }
    